import { format } from 'date-fns';
import { TZDate } from '@date-fns/tz';
import { nl } from 'date-fns/locale';

const TIMEZONE = 'Europe/Amsterdam';

/**
 * Format an ISO date string using a date-fns pattern with Dutch locale
 * in Amsterdam timezone.
 *
 * @example formatDate('2026-02-06T10:30:00.000Z')
 *          → '6 februari 2026 om 11:30'
 * @example formatDate('2024-01-01', 'd MMMM yyyy')
 *          → '1 januari 2024'
 * @example formatDate('2026-02-06', 'dd-MM-yyyy, HH:mm')
 *          → '06-02-2026, 11:30'
 */
export const formatDate = (iso: string, pattern = "d MMMM yyyy 'om' HH:mm"): string => {
  try {
    const trimmed = iso.trim();
    const hasTimezone = /Z|[+-]\d{2}:\d{2}$/.test(trimmed);
    const hasTime = trimmed.includes('T') || trimmed.includes(' ');
    const normalized = hasTime && !hasTimezone ? `${trimmed}Z` : trimmed;
    return format(new TZDate(normalized, TIMEZONE), pattern, { locale: nl });
  } catch {
    return iso;
  }
};

/**
 * Format a duration in seconds as MM:SS.
 *
 * @example formatTime(125) → '02:05'
 * @example formatTime(0) → '00:00'
 */
export const formatTime = (seconds: number): string => {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
};
